module.exports = __webpack_public_path__ + "pc/img/award2021_01.3f5c77f9.png";